import createAxiosInstance from './axiosConfig';
import { PromotoraDTO } from '../shared/dto/promotoraDTO';
import { PromotoraDocumentoDTO } from '../shared/dto/promotoraDocumentoDTO';
import { PromotoraGestaoAcaoDTO } from '../shared/dto/promotoraGestaoAcaoDTO';
import { PromotoraDadosGestaoDTO } from '../shared/dto/promotoraDadosGestaoDTO';
import { PromotoraParecerDTO } from '../shared/dto/promotoraParecerDTO';

export interface PromotoraContratoTemplateDTO {
  id?: number;
  nome?: string;
  tipoTemplate?: string;
  corpoHtml?: string;
  htmlPreVisualizacao?: string;
  nomeArquivo?: string;
  extensaoArquivo?: string;
  arquivoBase64?: string;
  ativo?: boolean;
  dtInclusao?: string;
  nomeUsuarioCadastro?: string;
}

export interface VariavelContratoPromotora {
  variavel: string;
  descricao: string;
}

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/promotoraController');

export default class PromotoraService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async listarTodasPromotorasAtivas() {
    return await this.axios.get(`/listarTodasPromotorasAtivas`);
  };

  async listarTodasPromotorasAquisicao(){
    return await this.axios.get(`/listarTodasPromotorasAquisicao`);
  };

  async listarTodasPromotorasAtivasPorRole() {
    return await this.axios.get(`/listarTodasPromotorasAtivasPorRole`);
  };

  async listarTodasPromotoras(page = 0, size = 10, filtros: any = {}) {
    return this.axios.post(`/listarTodasPromotoras`, filtros, {
      params: { page, size, ...filtros }
    });
  }

  async listarPromotorasGestao(page = 0, size = 10, filtros: any = {}) {
    return this.axios.post(`/listarPromotorasGestao`, filtros, {
      params: { page, size, ...filtros }
    });
  }

  async listarTodasPromotorasPorRole() {
    return await this.axios.get(`/listarTodasPromotorasPorRole`);
  };

  async ativarInativarPromotora(id: string) {
    return await this.axios.get(`/ativarInativarPromotora?id=${id}`);
  };

  async listarPromotoraPorId(id: string) {
    return await this.axios.get(`/listarPromotoraPorId?id=${id}`);
  };

  async incluirAlterarPromotora(dto: PromotoraDTO) {
    return await this.axios.post(`/incluirAlterarPromotora`, dto);
  };

  async buscarPorOriginador(idsOriginadores: any[]) {
    return await this.axios.post(`/buscarPorOriginador`, idsOriginadores);
  };

  async listarDocumentosPromotora(idPromotora: string | number) {
    return await this.axios.get(`/listarDocumentosPromotora?idPromotora=${idPromotora}`);
  };

  async incluirDocumentoPromotora(dto: PromotoraDocumentoDTO) {
    return await this.axios.post(`/incluirDocumentoPromotora`, dto);
  };

  async excluirDocumentoPromotora(idDocumento: string) {
    return await this.axios.delete(`/excluirDocumentoPromotora?idDocumento=${idDocumento}`);
  };

  async downloadDocumentoPromotora(idDocumento: string) {
    return await this.axios.get(`/downloadDocumentoPromotora?idDocumento=${idDocumento}`, {
      responseType: 'blob'
    });
  };

  async downloadModeloDocumentoPromotora(codigoChecklist: number) {
    return await this.axios.get(`/downloadModeloDocumentoPromotora?codigoChecklist=${codigoChecklist}`, {
      responseType: 'blob'
    });
  };

  async downloadLoteDocumentosPromotora(idPromotora: string | number) {
    return await this.axios.get(`/downloadLoteDocumentosPromotora?idPromotora=${idPromotora}`, {
      responseType: 'arraybuffer'
    });
  };

  async finalizarDocumentacaoPromotora(idPromotora: string | number) {
    return await this.axios.post(`/finalizarDocumentacaoPromotora?idPromotora=${idPromotora}`);
  };

  async aprovarPromotoraGestao(dto: PromotoraGestaoAcaoDTO) {
    return await this.axios.post(`/aprovarPromotoraGestao`, dto);
  };

  async aprovarAnalisePromotoraGestao(dto: PromotoraGestaoAcaoDTO) {
    return await this.axios.post(`/aprovarAnalisePromotoraGestao`, dto);
  };

  async reprovarPromotoraGestao(dto: PromotoraGestaoAcaoDTO) {
    return await this.axios.post(`/reprovarPromotoraGestao`, dto);
  };

  async solicitarMaisDocumentacaoPromotora(dto: PromotoraGestaoAcaoDTO) {
    return await this.axios.post(`/solicitarMaisDocumentacaoPromotora`, dto);
  };

  async enviarContratoAssinaturaPromotora(dto: PromotoraGestaoAcaoDTO) {
    return await this.axios.post(`/enviarContratoAssinaturaPromotora`, dto);
  };

  async listarJornadaPromotora(idPromotora: string | number) {
    return await this.axios.get(`/listarJornadaPromotora?idPromotora=${idPromotora}`);
  };

  async buscarDadosGestaoPromotora(idPromotora: string | number) {
    return await this.axios.get(`/buscarDadosGestaoPromotora?idPromotora=${idPromotora}`);
  };

  async salvarDadosGestaoPromotora(dto: PromotoraDadosGestaoDTO) {
    return await this.axios.post(`/salvarDadosGestaoPromotora`, dto);
  };

  async listarPareceresPromotora(idPromotora: string | number) {
    return await this.axios.get(`/listarPareceresPromotora?idPromotora=${idPromotora}`);
  };

  async registrarParecerPromotora(dto: PromotoraParecerDTO) {
    return await this.axios.post(`/registrarParecerPromotora`, dto);
  };

  async listarTemplatesContratoPromotora() {
    return await this.axios.get(`/listarTemplatesContratoPromotora`);
  };

  async buscarTemplateContratoPromotora(idTemplate: number | string) {
    return await this.axios.get(`/buscarTemplateContratoPromotora?idTemplate=${idTemplate}`);
  };

  async salvarTemplateContratoPromotora(dto: PromotoraContratoTemplateDTO) {
    return await this.axios.post(`/salvarTemplateContratoPromotora`, dto);
  };

  async excluirTemplateContratoPromotora(idTemplate: number) {
    return await this.axios.delete(`/excluirTemplateContratoPromotora?idTemplate=${idTemplate}`);
  };

  async preVisualizarTemplateContratoPromotora(dto: PromotoraContratoTemplateDTO, idPromotora?: string | number) {
    const query = idPromotora ? `?idPromotora=${idPromotora}` : '';
    return await this.axios.post(`/preVisualizarTemplateContratoPromotora${query}`, dto);
  };

  async listarVariaveisTemplateContratoPromotora() {
    return await this.axios.get(`/listarVariaveisTemplateContratoPromotora`);
  };

}
